<template>
  <fieldset
    class="divDateControlContainer ekkJSDateControl"
    :disabled="disabled"
    ref="ekkJSDateControl"
    @click.stop.prevent
  >
    <table>
      <tr>
        <td style="width:35%">
          <select v-model="year" ref="ddlYear">
            <option v-for="y in getYears" v-bind:key="y">{{y}}</option>
          </select>
        </td>
        <td style="width:35%">
          <select v-model="month">
            <option v-for="m in getMonths" v-bind:key="m">{{m}}</option>
          </select>
        </td>
        <td style="width:30%" v-if="showDate">
          <select v-model="date">
            <option v-for="d in getDates" v-bind:key="d">{{d}}</option>
          </select>
        </td>
        <td style="width:10%; " v-if="showDate" @click="toggleCalender">
          <div class="calImage"></div>
        </td>
      </tr>
    </table>
    <div class="CalenderContainer" @click.stop>
      <div class="CalenderDays" v-if="this.calView===0">
        <div class="CalenderDaysTitle">
          <div class="CalenderDaysTitlePrev" @click="changeCalenderDaysPrev">◄</div>
          <div class="CalenderDaysTitleName">
            <a v-on:click="showCalMonthView">{{calMonthName}}</a>
          </div>
          <div class="CalenderDaysTitleNext" @click="changeCalenderDaysNext">►</div>
        </div>
        <div class="CalenderDayNames">
          <div class="CalenderDayName" v-for="w in calWeekNames" :key="w">{{w}}</div>
        </div>
        <div class="CalenderDaysDates">
          <div
            class="CalenderDayDate"
            v-for="d in calMonthDates"
            v-bind:key="d.index"
            v-bind:currentmonth="d.isCurrentMonth"
            v-bind:current="d.isCurrent"
            v-bind:today="d.isToDay"
            v-bind:date="d.date"
            v-bind:day="d.dayName"
            v-on:click="changeCurrentDate($event)"
            v-bind:class="{disabled:!d.isActive}"
          >{{d.dd}}</div>
        </div>
      </div>
      <div class="CalenderMonths" v-if="this.calView===1">
        <div class="CalenderMonthsTitle">
          <div class="CalenderMonthsTitlePrev" @click="changeCalenderMonthsPrev">◄</div>
          <div class="CalenderMonthsTitleName">
            <a v-on:click="showCalYearView">{{getYearName}}</a>
          </div>
          <div class="CalenderMonthsTitleNext" @click="changeCalenderMonthsNext">►</div>
        </div>
        <div class="CalenderMonthsNames">
          <div
            class="CalenderMonthsName"
            v-for="m in getMonthNames"
            :key="m.date"
            :date="m.date"
            @click="changeCurrentMonth"
          >{{m.monthName}}</div>
        </div>
      </div>
      <div class="CalenderYears" v-if="this.calView===2">
        <div class="CalenderYearsTitle">
          <div class="CalenderYearsTitlePrev" @click="changeCalenderYearsPrev">◄</div>
          <div class="CalenderYearsTitleName">{{getYearsRange}}</div>
          <div class="CalenderYearsTitleNext" @click="changeCalenderYearsNext">►</div>
        </div>
        <div class="CalenderYearsNames">
          <div
            class="CalenderYearsName"
            v-for="y in getYearsNames"
            :key="y.date"
            :date="y.date"
            @click="changeCurrentYear"
          >{{y.yearName}}</div>
        </div>
      </div>
      <div class="CalenderCurrentDate">
        <a v-bind:Date="currentDate.value" @click="changeCurrentDate($event)">{{currentDate.text}}</a>
      </div>
    </div>
  </fieldset>
</template>
<script>
export default {
  props: {
    value: { default: "1-Jan-1900" },
    plusYears: { type: Number, default: 10 },
    showDate: { type: Boolean, default: true },
    fromDate: { default: "1-Jan-1900" },
    toDate: { default: "1-Jan-1900" },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      dateValue: new Date(),
      dmy: { d: "Day", m: "Month", y: "Year" },
      calDate: new Date(),
      calView: 0
    };
  },
  methods: {
    toggleCalender(e) {
      if (e.target.closest("[disabled]")) {
        return;
      }
      this.calView = 0;
      let obj = e.target;
      let divDateControlContainer = e.target.closest(
        ".divDateControlContainer"
      );
      let CalenderContainer = divDateControlContainer.querySelector(
        ".CalenderContainer"
      );
      if (CalenderContainer.isVisible()) {
        CalenderContainer.hide();
      } else {
        if (this.dateValue.format("dd/MMM/yyyy") !== "01/Jan/1900") {
          this.calDate = this.dateValue;
        }
        CalenderContainer.showAsDropDown(divDateControlContainer);
        let documentBodyClick = function(e) {
          if (e.target !== obj) {
            CalenderContainer.hide();
          } else {
            document.body.one("click", documentBodyClick);
          }
        };
        document.body.one("click", documentBodyClick);
      }
    },
    isActive(d) {
      let fromDate =
        typeof this.fromDate == "string"
          ? this.fromDate.toDateTime()
          : this.fromDate;
      let toDate =
        typeof this.toDate == "string" ? this.toDate.toDateTime() : this.toDate;
      if (fromDate < toDate) {
        if (d < fromDate || d > toDate) {
          return false;
        }
      }
      return true;
    },
    changeCurrentDate(e) {
      let d = e.target.getAttribute("date").toDateTime();
      if (!this.isActive(d)) {
        return;
      }
      this.dmy.d = d.getDate();
      this.dmy.m = d.format("MMM");
      this.dmy.y = d.getFullYear();
      if (typeof this.value === "string") {
        this.$emit("input", this.getDMYDate.convertToString("dd-MMM-yyyy"));
      } else {
        this.$emit("input", this.getDMYDate);
      }
      this.$refs.ekkJSDateControl.classList.remove("invalidInput");
      e.target.closest(".CalenderContainer").hide();
    },
    changeCalenderDaysPrev() {
      this.calDate = this.calDate.addMonths(-1);
    },
    changeCalenderDaysNext() {
      this.calDate = this.calDate.addMonths(1);
    },
    showCalMonthView() {
      this.calView = 1;
    },
    changeCalenderMonthsPrev() {
      this.calDate = this.calDate.addYears(-1);
    },
    changeCalenderMonthsNext() {
      this.calDate = this.calDate.addYears(1);
    },
    showCalYearView() {
      this.calView = 2;
    },
    changeCurrentMonth(e) {
      this.calDate = e.target.getAttribute("date").toDateTime();
      this.calView = 0;
    },
    changeCalenderYearsPrev() {
      this.calDate = this.calDate.addYears(-20);
    },
    changeCalenderYearsNext() {
      this.calDate = this.calDate.addYears(20);
    },
    changeCurrentYear(e) {
      this.calDate = e.target.getAttribute("date").toDateTime();
      this.calView = 1;
    },
    focus() {
      this.$refs.ddlYear.focus();
    }
  },
  computed: {
    getYears() {
      let Years = [];
      let yy = new Date().getFullYear() + this.plusYears;
      Years.push("Year");
      if (this.dateValue.getFullYear() > yy) {
        Years.push(this.dateValue.getFullYear());
      }
      for (let y = yy; y >= 1900; y--) {
        Years.push(y);
      }
      if (this.dateValue.getFullYear() < 1900) {
        Years.push(this.dateValue.getFullYear());
      }
      return Years;
    },
    year: {
      get() {
        return this.dmy.y;
      },
      set(y) {
        let _y = this.dmy.y;
        this.dmy.y = y;
        let dd = this.getDMYDate;
        if (dd.format("dd/MMM/yyyy") != "01/Jan/1900") {
          if (!this.isActive(dd)) {
            this.dmy.y = _y;
          }
        }
        if (!this.showDate) {
          this.dmy.d = 1;
        }
        if (typeof this.value === "string") {
          this.$emit("input", this.getDMYDate.convertToString("dd-MMM-yyyy"));
        } else {
          this.$emit("input", this.getDMYDate);
        }
      }
    },
    getMonths() {
      let months = [];
      months.push("Month");
      months.push("Jan");
      months.push("Feb");
      months.push("Mar");
      months.push("Apr");
      months.push("May");
      months.push("Jun");
      months.push("Jul");
      months.push("Aug");
      months.push("Sep");
      months.push("Oct");
      months.push("Nov");
      months.push("Dec");
      return months;
    },
    month: {
      get() {
        return this.dmy.m;
      },
      set(m) {
        let _m = this.dmy.m;
        this.dmy.m = m;
        let dd = this.getDMYDate;
        if (dd.format("dd/MMM/yyyy") != "01/Jan/1900") {
          if (!this.isActive(dd)) {
            this.dmy.m = _m;
          }
        }
        if (!this.showDate) {
          this.dmy.d = 1;
        }
        if (typeof this.value === "string") {
          this.$emit("input", this.getDMYDate.convertToString("dd-MMM-yyyy"));
        } else {
          this.$emit("input", this.getDMYDate);
        }
      }
    },
    getDates() {
      let dd = [];
      dd.push("Day");
      let D = this.dateValue
        .format("01/MMM/yyyy")
        .toDateTime()
        .addMonths(1)
        .addDays(-1)
        .getDate();

      for (let d = 1; d <= D; d++) {
        dd.push(d);
      }
      return dd;
    },
    date: {
      get() {
        return this.dmy.d;
      },
      set(d) {
        let _d = this.dmy.d;
        this.dmy.d = d;
        let dd = this.getDMYDate;
        if (dd.format("dd/MMM/yyyy") != "01/Jan/1900") {
          if (!this.isActive(dd)) {
            this.dmy.d = _d;
          }
        }
        if (!this.showDate) {
          this.dmy.d = 1;
        }
        if (typeof this.value === "string") {
          this.$emit("input", this.getDMYDate.convertToString("dd-MMM-yyyy"));
        } else {
          this.$emit("input", this.getDMYDate);
        }
      }
    },
    getDMYDate() {
      let date = this.dmy.d + "/" + this.dmy.m + "/" + this.dmy.y;

      if (this.dmy.m === "Month") {
        return new Date("1/Jan/1900");
      } else {
        return date.toDateTime();
      }
    },
    currentDate() {
      let d = new Date();
      return {
        value: d.format("dd/MMM/yyyy"),
        text: d.format("dddd dd-MMM-yyyy")
      };
    },
    calMonthName() {
      return this.calDate.format("MMMM, yyyy");
    },
    calWeekNames() {
      return ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    },
    calMonthDates() {
      let Dates = [];
      let d = this.calDate.format("01/MMM/yyyy").toDateTime();
      let ddd = d.getDay();
      d = d.addDays(-ddd);
      for (let i = 0; i < 42; i++) {
        let dd = d.addDays(i);
        Dates.push({
          index: i,
          dd: dd.getDate(),
          date: dd.format("dd/MMM/yyyy"),
          isCurrent:
            dd.format("dd/MMM/yyyy") === this.dateValue.format("dd/MMM/yyyy"),
          isCurrentMonth: dd.getMonth() === this.calDate.getMonth(),
          isToDay:
            dd.format("dd/MMM/yyyy") === new Date().format("dd/MMM/yyyy"),
          dayName: dd.format("ddd"),
          isActive: this.isActive(dd)
        });
      }

      return Dates;
    },
    getMonthNames() {
      let mm = [];
      let d = this.calDate.format("01-Jan-yyyy").toDateTime();
      for (let i = 0; i < 12; i++) {
        let m = d.addMonths(i);
        mm.push({ date: m.format("dd/MMM/yyyy"), monthName: m.format("MMM") });
      }
      return mm;
    },
    getYearName() {
      return this.calDate.format("yyyy");
    },
    getYearsNames() {
      let yy = [];
      let y = this.calDate.getFullYear();
      y = y - (y % 20);
      let d = ("01-Jan-" + y).toDateTime();
      for (let i = 0; i < 20; i++) {
        let x = d.addYears(i);
        yy.push({ date: x.format("dd/MMM/yyyy"), yearName: x.format("yyyy") });
      }
      return yy;
    },
    getYearsRange() {
      let y = this.calDate.getFullYear();
      y = y - (y % 20);
      return y + " - " + (y + 20);
    },
    classList() {
      return this.$refs.ekkJSDateControl.classList;
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (typeof newValue === "string") {
        this.dateValue = newValue.toDateTime();
      } else {
        this.dateValue = newValue;
      }
      if (this.dateValue.format("dd/MMM/yyyy") === "01/Jan/1900") {
        if (
          this.dmy.y !== "Year" &&
          this.dmy.m !== "Month" &&
          this.dmy.d !== "Day"
        ) {
          this.dmy = { d: "Day", m: "Month", y: "Year" };
        }
        this.calDate = new Date();
      } else {
        this.dmy.d = this.dateValue.getDate();
        this.dmy.m = this.dateValue.format("MMM");
        this.dmy.y = this.dateValue.getFullYear();
        this.calDate = this.dateValue;
      }
    }
  },
  created() {
    if (typeof this.value === "string") {
      this.dateValue = this.value.toDateTime();
    } else {
      this.dateValue = this.value;
    }

    if (this.dateValue.format("dd/MMM/yyyy") !== "01/Jan/1900") {
      this.dmy.d = this.dateValue.getDate();
      this.dmy.m = this.dateValue.format("MMM");
      this.dmy.y = this.dateValue.getFullYear();
      this.calDate = this.dateValue;
    }
  }
};
</script>
<style>
.divDateControlContainer {
  max-width: 210px;
  padding: 0px;
  border: none;
  margin: 0px;
  background-color: transparent;
}
.divDateControlContainer table {
  width: 100%;
}
.CalenderContainer {
  position: fixed;
  background-color: black;
  color: white;
  border: solid 1px;
  border-radius: 10px;
  padding: 5px;
  min-width: 100px;
  min-height: 100px;
  z-index: 1;
  display: none;
  width: 200px !important;
}
.CalenderContainer .CalenderCurrentDate {
  text-align: center;
  padding-top: 5px;
}
.CalenderContainer .CalenderCurrentDate:hover {
  color: rgb(255, 136, 0);
}
.CalenderContainer .CalenderDays {
  border: solid 1px gray;
  width: 100%;
}
.CalenderContainer .CalenderDays .CalenderDaysTitle {
  border: solid 1px;
  display: flex;
}
.CalenderContainer .CalenderDays .CalenderDaysTitle .CalenderDaysTitlePrev {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderDays
  .CalenderDaysTitle
  .CalenderDaysTitlePrev:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.CalenderContainer .CalenderDays .CalenderDaysTitle .CalenderDaysTitleName {
  flex-grow: 1;
  flex-shrink: 1;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.CalenderContainer .CalenderDays .CalenderDaysTitle .CalenderDaysTitleNext {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderDays
  .CalenderDaysTitle
  .CalenderDaysTitleNext:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.CalenderContainer .CalenderDays .CalenderDayNames {
  display: flex;
}
.CalenderContainer .CalenderDays .CalenderDayNames .CalenderDayName {
  background-color: rgba(255, 255, 255, 0.4);
  width: 27px;
  text-align: center;
  padding: 2px;
}
.CalenderContainer
  .CalenderDays
  .CalenderDayNames
  .CalenderDayName:first-child {
  color: rgb(255, 136, 0);
}
.CalenderContainer .CalenderDays .CalenderDaysDates {
  display: flex;
  flex-wrap: wrap;
  padding: 2px;
}
.CalenderContainer .CalenderDays .CalenderDaysDates .CalenderDayDate {
  background-color: rgba(255, 255, 255, 0.2);
  color: #6b6b6b;
  border-radius: 5px;
  width: 25px;
  height: 25px;
  margin-right: 1px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(255, 255, 255, 0);
  transition: all 300ms;
}
.CalenderContainer .CalenderDays .CalenderDaysDates .CalenderDayDate:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border: solid 1px rgba(255, 255, 255, 0.5);
}
.CalenderContainer
  .CalenderDays
  .CalenderDaysDates
  .CalenderDayDate[currentmonth] {
  color: white;
}

.CalenderContainer
  .CalenderDays
  .CalenderDaysDates
  .CalenderDayDate[day="Sun"] {
  color: rgb(238, 221, 202);
}
.CalenderContainer .CalenderDays .CalenderDaysDates .CalenderDayDate.disabled {
  color: #404040;
}
.CalenderContainer .CalenderDays .CalenderDaysDates .CalenderDayDate[today] {
  background-color: rgb(250, 183, 0);
  color: white;
}
.CalenderContainer .CalenderDays .CalenderDaysDates .CalenderDayDate[current] {
  background-color: rgb(255, 136, 0);
  color: white;
}
.CalenderContainer .CalenderMonths {
  border: solid 1px gray;
  width: 100%;
}
.CalenderContainer .CalenderMonths .CalenderMonthsTitle {
  border: solid 1px;
  display: flex;
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsTitle
  .CalenderMonthsTitlePrev {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsTitle
  .CalenderMonthsTitlePrev:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsTitle
  .CalenderMonthsTitleName {
  flex-grow: 1;
  flex-shrink: 1;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsTitle
  .CalenderMonthsTitleNext {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsTitle
  .CalenderMonthsTitleNext:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.CalenderContainer .CalenderMonths .CalenderMonthsNames {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 1px;
}
.CalenderContainer .CalenderMonths .CalenderMonthsNames .CalenderMonthsName {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 5px;
  width: 60px;
  height: 40px;
  margin-left: 1px;
  margin-top: 1px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(255, 255, 255, 0);
  transition: all 300ms;
}
.CalenderContainer
  .CalenderMonths
  .CalenderMonthsNames
  .CalenderMonthsName:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border: solid 1px rgba(255, 255, 255, 0.5);
}
.CalenderContainer .CalenderYears {
  border: solid 1px gray;
  width: 100%;
}
.CalenderContainer .CalenderYears .CalenderYearsTitle {
  border: solid 1px;
  display: flex;
}
.CalenderContainer .CalenderYears .CalenderYearsTitle .CalenderYearsTitlePrev {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderYears
  .CalenderYearsTitle
  .CalenderYearsTitlePrev:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.CalenderContainer .CalenderYears .CalenderYearsTitle .CalenderYearsTitleName {
  flex-grow: 1;
  flex-shrink: 1;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.CalenderContainer .CalenderYears .CalenderYearsTitle .CalenderYearsTitleNext {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
  cursor: pointer;
  transition: all 300ms;
}
.CalenderContainer
  .CalenderYears
  .CalenderYearsTitle
  .CalenderYearsTitleNext:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.CalenderContainer .CalenderYears .CalenderYearsNames {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 1px;
}
.CalenderContainer .CalenderYears .CalenderYearsNames .CalenderYearsName {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 5px;
  width: 44px;
  height: 35px;
  margin-left: 1px;
  margin-top: 1px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: solid 1px rgba(255, 255, 255, 0);
  transition: all 300ms;
}
.CalenderContainer .CalenderYears .CalenderYearsNames .CalenderYearsName:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border: solid 1px rgba(255, 255, 255, 0.5);
}
.calImage {
  background-image: url("data:image/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAACcElEQVR42pySO2gUURSGv9lspVgqgs00i1hYprISLExlr3axFSytxRBB4gqiIlHBrCJ5kEREJT5iBEVFNyoGiYubSZQYk+xGZ2c22Zl77zkWuwmCBMG/+f/7gPPdcy6qip/z9XLvtUMtP+jnfL3ed3O/n/O1J58/6ed8PZfPH/Nzvl68dHG3n/O1f6D/6J69e05kzvacLwalgCisjQalgMX5b1eCUsDXmS/jzf2wOygFfJ2b6w1KAZPFyenydJmRkZHC8MBw3js7sKTOKcYpxgqpFVIjJEZIU6FhHGnaWpvmubGCcYpzShbg8IHtKKAKok1XVYZeWYwFa1MAxHpY8dCMR2Is4y8+R1mA/qcVrICxirFKaiExQmKUhtGmp0pihdRAahQjgFi4ff+tioiKiHYViptmY0UbqdOuQlF/xU4rodH2jk7NiirriuPaptmJYl0zGxEWFubJZtvwbt59raHdyuJylTAM2bFzF/W4Rj2ONvLp7CPcwhxmZopwtsz1zmesrUaMjRag787LTbFtC9ucOqLWisZrTkv7tujsUqoPn09pe0enZkRkU2zbwjYzUzRMM1cTwVgwrnkvK+q4fOcTi8tVVuOI7lvvqMc1VuOInv731OMax2fLRAe2UU2EauIYf/KR+nqxq4MTG9hnbk22sGWj20uh0a5CUWeXjJZ/pNpVKOqHuURHHn9sTcHJX9hOoNGIsSKotqagSlvGI01iREA9b/0Jwo2xz8wvVIlqNQYnylRWfrIWR9x7OcO378usxRETb8t8X6zw62fIxJtpKisrAHgX+h5o3+2hDYq2TAb3R2P/JU//+Ej/o98DAJuaMw34Mg6lAAAAAElFTkSuQmCC");
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
}
.ekkJSDateControl.invalidInput select {
  border: solid 1px red;
  background-image: linear-gradient(rgba(255, 0, 0, 0.1));
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/DateControl.vue